/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { CreateClientApiArg, CreateClientData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createClient: build.mutation<CreateClientData, CreateClientApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/clients`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as createClientApi };
export const { useCreateClientMutation } = injectedRtkApi;
